import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.concat.js";
import React, { Fragment, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Text from 'components/Text';
import Stack from 'components/Stack';
import Heading from 'components/Heading';
import Icon from 'components/Icon';
import FriendlyDuration from 'components/FriendlyDuration';
import Button from 'components/Button';
import TextLink from 'components/TextLink';
function QuoteBlock(_ref) {
  var skillId = _ref.skillId,
    quotes = _ref.quotes,
    title = _ref.title,
    getLocation = _ref.getLocation;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showMore = _useState2[0],
    setShowMore = _useState2[1];
  var displayedQuotes = showMore || quotes.length <= 1 ? quotes : [quotes[0]];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Heading, {
    as: "h4",
    size: "small",
    mb: "xs"
  }, title), /*#__PURE__*/React.createElement(Stack, {
    spacing: "s"
  }, displayedQuotes.map(function (quote, index) {
    var text = quote.text,
      reasoning = quote.reasoning,
      startTime = quote.startTime,
      meetingTitle = quote.meetingTitle,
      meetingId = quote.meetingId;
    var hasInvalidStartTime = typeof startTime !== 'number' || isNaN(startTime);
    return /*#__PURE__*/React.createElement(Fragment, {
      key: "".concat(text, "-").concat(index)
    }, /*#__PURE__*/React.createElement(Stack, {
      spacing: "xxs"
    }, /*#__PURE__*/React.createElement(React.Fragment, null, meetingTitle && /*#__PURE__*/React.createElement(React.Fragment, null, meetingId && getLocation ? /*#__PURE__*/React.createElement(TextLink, {
      bold: true,
      as: Link,
      to: getLocation({
        meetingId: meetingId,
        searchSkillId: skillId
      })
    }, meetingTitle) : /*#__PURE__*/React.createElement(Text, {
      bold: true
    }, meetingTitle), hasInvalidStartTime && /*#__PURE__*/React.createElement(Text, {
      bold: true,
      mr: "xxs"
    }, ":")), meetingTitle && !hasInvalidStartTime && /*#__PURE__*/React.createElement(Text, {
      mx: "xxs",
      bold: true
    }, "-"), !hasInvalidStartTime && /*#__PURE__*/React.createElement(Text, {
      bold: true,
      mr: "xxs"
    }, /*#__PURE__*/React.createElement(FriendlyDuration, {
      value: startTime,
      showSeconds: true
    }), ":"), /*#__PURE__*/React.createElement(Text, {
      style: {
        fontStyle: 'italic'
      }
    }, "\"", text, "\"")), /*#__PURE__*/React.createElement(Text, null, reasoning)));
  })), quotes.length > 1 && /*#__PURE__*/React.createElement(Button, {
    mt: "xs",
    variant: "transparent",
    size: "small",
    onClick: function onClick() {
      return setShowMore(!showMore);
    },
    icon: /*#__PURE__*/React.createElement(Icon, {
      name: "chevron",
      rotate: showMore ? -180 : 0
    })
  }, t(showMore ? 'actions_show_less' : 'actions_show_more')));
}
function QuoteSection(_ref2) {
  var skillId = _ref2.skillId,
    positiveSkillUsage = _ref2.positiveSkillUsage,
    negativeSkillUsage = _ref2.negativeSkillUsage,
    getLocation = _ref2.getLocation;
  var _useTranslation2 = useTranslation(),
    t = _useTranslation2.t;
  return /*#__PURE__*/React.createElement(Stack, {
    spacing: "s"
  }, (positiveSkillUsage === null || positiveSkillUsage === void 0 ? void 0 : positiveSkillUsage.length) > 0 && /*#__PURE__*/React.createElement(QuoteBlock, {
    skillId: skillId,
    title: t('property_positive_relevant_quotes'),
    quotes: positiveSkillUsage,
    getLocation: getLocation
  }), (negativeSkillUsage === null || negativeSkillUsage === void 0 ? void 0 : negativeSkillUsage.length) > 0 && /*#__PURE__*/React.createElement(QuoteBlock, {
    skillId: skillId,
    title: t('property_negative_relevant_quotes'),
    quotes: negativeSkillUsage,
    getLocation: getLocation
  }));
}
export default QuoteSection;